import * as React from "react";
import {Types}    from "@Common/types";

export class UseObserver<T> extends React.Component<Types.Xpresso.Account.Admin.UserManagement.UseObserverProps<T>>
{
    private observer:Types.Xpresso.Account.Admin.UserManagement.Observer;
    private targetRef:React.RefObject<HTMLElement> = React.createRef();

    componentDidMount()
    {
        this.observer = this.props.makeObserver(this.handleEntries.bind(this));
        if (this.targetRef.current)
            this.observer.observe(this.targetRef.current);
    }

    componentDidUpdate()
    {
        if (this.targetRef.current)
            this.observer.observe(this.targetRef.current);
    }

    componentWillUnmount()
    {
        this.observer.disconnect();
    }

    handleEntries(entries:T[])
    {
        this.props.onEntries(entries);
    }

    render()
    {
        const {next} = this.props;
        return next({targetRef:this.targetRef});
    }
}
